export const listUsers = `
items {
  id
  sk
  createdAt
  firstName
  lastName
  email
}
nextToken
total
__typename
`;

export const getUserRecents = `
id
sk
recentResources {
  items {
    id
    sk
    idInc
    type
    name
    isDeleted
    isArchived
    isUserFavorite
    isUserWatcher
    createdAt
    updatedAt
  }
}
`;

export const onCreateUserNotificationRecord = `
id
sk
createdAt
updatedAt
status
type
title
body
file {
  region
  bucket
  key
}
job {
  id
  sk
  name
  outputFile {
    region
    bucket
    key
  }
}
data
workspaceId
notification {
  type
  title
  body
  file {
    bucket
    region
    key
  }
  payload
}
`;
